import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, fmtDate, fmtNum } from "../lib/api";
import { PageHeader, StatusBadge, Empty } from "../components/common";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Plus, ArrowUpRight } from "lucide-react";

export default function Campaigns() {
  const [items, setItems] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [tpl, setTpl] = useState("");
  const nav = useNavigate();
  useEffect(() => {
    api.get("/campaigns").then((r) => setItems(r.data));
    api.get("/templates").then((r) => { setTemplates(r.data); if (r.data[0]) setTpl(r.data[0].id); });
  }, []);
  const create = async () => {
    try {
      const r = await api.post("/campaigns", { name, template_id: tpl || null });
      toast.success("Campagne créée (brouillon)");
      nav(`/campaigns/${r.data.id}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader eyebrow="Envois" title="Campagnes" description="Aucun email n'est envoyé avant votre validation explicite du lancement."
        actions={<Button onClick={() => setOpen(true)} data-testid="new-campaign-btn"><Plus className="h-4 w-4 mr-2" />Nouvelle campagne</Button>} />
      {items.length === 0 ? <Empty title="Aucune campagne">Créez une campagne, ajoutez des contacts vérifiés, puis validez le lancement.</Empty> : (
        <div className="border border-slate-200 rounded-md overflow-hidden">
          <table className="w-full text-sm" data-testid="campaigns-table">
            <thead className="bg-slate-50 text-left text-xs text-slate-500"><tr>{["Campagne", "Statut", "Contacts", "En file", "Emails envoyés", "Réponses", "Rebonds", "Créée", ""].map((h) => <th key={h} className="px-4 py-2.5 font-medium">{h}</th>)}</tr></thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-t border-slate-100 row-hover cursor-pointer" onClick={() => nav(`/campaigns/${c.id}`)} data-testid={`campaign-row-${c.id}`}>
                  <td className="px-4 py-3 font-medium">{c.name}</td>
                  <td className="px-4"><StatusBadge status={c.status} /></td>
                  <td className="px-4 tabular">{fmtNum(c.counts.total)}</td>
                  <td className="px-4 tabular">{fmtNum(c.counts.queued)}</td>
                  <td className="px-4 tabular">{fmtNum(c.counts.emails_sent)}</td>
                  <td className="px-4 tabular">{fmtNum(c.counts.replied)}</td>
                  <td className="px-4 tabular">{fmtNum(c.counts.bounced)}</td>
                  <td className="px-4 text-xs text-slate-500">{fmtDate(c.created_at)}</td>
                  <td className="px-3"><Link to={`/campaigns/${c.id}`}><ArrowUpRight className="h-4 w-4 text-slate-400" /></Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="new-campaign-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">Nouvelle campagne</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div className="space-y-1"><Label className="text-xs">Nom</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="new-campaign-name" /></div>
            <div className="space-y-1"><Label className="text-xs">Modèle d'email</Label>
              <Select value={tpl} onValueChange={setTpl}><SelectTrigger data-testid="new-campaign-template"><SelectValue placeholder="Choisir" /></SelectTrigger>
                <SelectContent>{templates.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent></Select>
            </div>
            <p className="text-xs text-slate-500">Les horaires, limites et relances par défaut (Paramètres) sont appliqués et restent modifiables.</p>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Annuler</Button><Button disabled={!name.trim()} onClick={create} data-testid="new-campaign-submit">Créer</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
